import { render, staticRenderFns } from "./InsPromotion.vue?vue&type=template&id=110c2e40&scoped=true"
import script from "./InsPromotion.vue?vue&type=script&lang=ts"
export * from "./InsPromotion.vue?vue&type=script&lang=ts"
import style0 from "./InsPromotion.vue?vue&type=style&index=0&id=110c2e40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110c2e40",
  null
  
)

export default component.exports